import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import dotenv from 'dotenv'
import axios from 'axios'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import 'react-toastify/dist/ReactToastify.css'
import Postcard from '../../Components/Card/Postcard'
import { ToastContainer } from 'react-toastify'
import Loader from 'react-loader-spinner'
import './PostsStyle.css'
import { NavBar } from '../../Components/Navigation/NavBar'
import { Footer } from '../../Components/Footer/Footer'
dotenv.config()

const Posts = () => {
  const [posts, setPosts] = useState([])
  const [morePosts, setMorePosts] = useState([])
  const [nextPage, setNextPage] = useState()
  const [renderPage, setRenderPage] = useState(false)
  const BASE_URL = 'https://www.googleapis.com/blogger/v3/blogs/'

  const getAllPosts = () => {
    axios
      .get(
        BASE_URL +
          process.env.REACT_APP_BLOG_ID +
          '/posts?key=' +
          process.env.REACT_APP_BLOG_API_KEY
      )
      .then((response) => {
        setPosts(response.data.items)
        setNextPage(response.data.nextPageToken)
        setRenderPage(true)
      })
      .catch((err) => {
        console.log('Error occured while getting the posts: ' + err)
      })
  }

  useEffect(() => {
    getAllPosts()
  }, [])

  const getMorePosts = (getMorePostsUrl) => {
    setRenderPage(false)
    axios
      .get(getMorePostsUrl)
      .then((response) => {
        setNextPage(response.data.nextPageToken)
        setMorePosts(response.data.items)
        setPosts(response.data.items)
        setRenderPage(true)
      })
      .catch((err) => {
        console.log('Error occured while fetching More posts: ' + err)
      })
  }

  const onMorePostsButtonClick = () => {
    const getMorePostsUrl =
      BASE_URL +
      process.env.REACT_APP_BLOG_ID +
      '/posts?key=' +
      process.env.REACT_APP_BLOG_API_KEY +
      '&pageToken=' +
      nextPage
    console.log(getMorePostsUrl)
    getMorePosts(getMorePostsUrl)
  }

  return (
    <React.Fragment>
       <NavBar />
      {renderPage ? (
        <div>
          <ToastContainer />
          {console.log('Posts', posts.length)}
          {console.log('More posts', morePosts.length)}
          {posts.map((post) => {
            return (
              <div key={post.id}>
                <Postcard
                  key={post.id}
                  postId={post.id}
                  title={post.title}
                  content={post.content}
                  imageUrl={
                    post.content &&
                    post.content.match(/src=(.+?[.jpg|.gif|.png]")/)[1]
                  }
                  date={post.updated}
                  author={post.author.displayName}
                />
              </div>
            )
          })}
          {
            <div className="more-button ">
              {nextPage && (
                <Button
                  className="btn"
                  type="submit"
                  onClick={onMorePostsButtonClick}
                >
                  See More Posts{' '}
                </Button>
              )}
            </div>
          }
        </div>
      ) : (
        <Loader
          type="TailSpin"
          color="teal"
          height={100}
          width={100}
          timeout={3000} //3 secs
          className="loader"
        />
      )}
      <Footer/>
    </React.Fragment>
  )
}

export default Posts
